// 定义各个档位的功能权限，避免重复定义
const features = {
	free: {
		multiple_lip_sync_models: false,
		select_video_loop_mode: false,
		private_video_visibility: false,
		video_upload_limit: 50,
		audio_upload_limit: 10,
		unlimited_upload: false,
		unlimited_text_to_audio: false,
		permanent_storage: false
	},
	base: {
		multiple_lip_sync_models: true,
		select_video_loop_mode: false,
		private_video_visibility: false,
		video_upload_limit: 50,
		audio_upload_limit: 10,
		unlimited_upload: false,
		unlimited_text_to_audio: false,
		permanent_storage: false
	},
	premium: {
		multiple_lip_sync_models: true,
		select_video_loop_mode: true,
		private_video_visibility: true,
		video_upload_limit: 100,
		audio_upload_limit: 20,
		unlimited_upload: false,
		unlimited_text_to_audio: true,
		permanent_storage: false
	},
	pro: {
		multiple_lip_sync_models: true,
		select_video_loop_mode: true,
		private_video_visibility: true,
		video_upload_limit: 999999,
		audio_upload_limit: 999999,
		unlimited_upload: true,
		unlimited_text_to_audio: true,
		permanent_storage: true
	}
};

export const SubscriptionPlans = [
	// --- Free Plan ---
	{
		name: "Free",
		slug: "free-monthly",
		tier: "free",
		duration: "/month",
		price: 0,
		credits: 60,
		priceId: "",
		features: features.free
	},

	// --- Base Plan ---
	{
		name: "Base",
		slug: "base-monthly",
		tier: "base",
		duration: "/month",
		price: 9,
		credits: 600,
		priceId: process.env.NODE_ENV === "development" ? "price_1Sk1Nw8X3hBCQQwjFUeTFHLW" : "price_1SkRsA8X3hBCQQwjSVmAxMFE",
		features: features.base
	},
	{
		name: "Base",
		slug: "base-yearly",
		tier: "base",
		duration: "/year",
		price: 7, 
		price_yearly: 84,
		credits: 600,
		priceId: process.env.NODE_ENV === "development" ? "price_1Sk1YL8X3hBCQQwjCgsDP3G2" : "price_1SkRsW8X3hBCQQwjuSbmMLAE",
		features: features.base,
		discountOff: 20 
	},

	// --- Premium Plan ---
	{
		name: "Premium",
		slug: "premium-monthly",
		tier: "premium",
		duration: "/month",
		price: 19,
		credits: 1800,
		priceId: process.env.NODE_ENV === "development" ? "price_1Sk1az8X3hBCQQwj8UlqlQtS" : "price_1SkRtd8X3hBCQQwj3eyJpOUp",
		features: features.premium
	},
	{
		name: "Premium",
		slug: "premium-yearly",
		tier: "premium",
		duration: "/year",
		price: 15,
		price_yearly: 180,
		credits: 1800,
		priceId: process.env.NODE_ENV === "development" ? "price_1Sk1bC8X3hBCQQwjDhUuid6u" : "price_1SkRts8X3hBCQQwjp3q96f3Q",
		features: features.premium,
		discountOff: 20
	},

	// --- Pro Plan ---
	{
		name: "Pro",
		slug: "pro-monthly",
		tier: "pro",
		duration: "/month",
		price: 69,
		credits: 9600,
		priceId: process.env.NODE_ENV === "development" ? "price_1Sk1cZ8X3hBCQQwjrppPv7Kq" : "price_1SkRuT8X3hBCQQwjPYlh40Ve",
		features: features.pro
	},
	{
		name: "Pro",
		slug: "pro-yearly",
		tier: "pro",
		duration: "/year",
		price: 60,
		price_yearly: 720,
		credits: 9600,
		priceId: process.env.NODE_ENV === "development" ? "price_1Sk1co8X3hBCQQwjCYhn9h0j" : "price_1SkRun8X3hBCQQwjRumBcTrP",
		features: features.pro,
		discountOff: 20
	}
];

export const getPlanBySlug = (slug) => {
	// 如果 slug 不包含 monthly/yearly，尝试匹配 tier
	const plan = SubscriptionPlans.find(p => p.slug === slug);
	if (plan) return plan;

	// 降级逻辑：如果传的是 'base'，默认返回 'base-monthly'
	const fallback = SubscriptionPlans.find(p => p.tier === slug && p.duration === "/month");
	return fallback || SubscriptionPlans[0];
};
